"use strict";

(function( namespace ) {
	namespace.AnalyticsEvents = function( playerInst, data, siteData ) {
		var gaTag;
		var comScore;
		var playerData = data || {};
		var adDuration = 0;
		var beforePlay = false;
		var player = playerInst;
		var site_data = siteData;
		var ignoreNextPlay = true;
		var ignoreNextPause = false;

		var init = function() {
			setPlayerEvents();
		};

		var updateGATag = function() {
			var tagStr = [ playerData.embed_id, playerData.video_id, playerData.urlHash, playerData.referral, playerData.fullUrl ];
			tagStr.push( ( "autoplay" in playerData ) ? ( ( playerData.autoplay ) ? 1 : 0 ) : 0 );
			tagStr.push( ( "disable_ads" in playerData ) ? ( ( playerData.disable_ads ) ? 1 : 0 ) : 0 );
			tagStr.push( ( "mute" in playerData ) ? ( ( playerData.mute ) ? 1 : 0 ) : 0 );
			tagStr.push( ( "playerType" in playerData && playerData.playerType ) ? playerData.playerType : "" );
			tagStr.push( ( "playerWidth" in playerData && playerData.playerWidth ) ? playerData.playerWidth : "" );
			tagStr.push( ( "playerHeight" in playerData && playerData.playerHeight ) ? playerData.playerHeight : "" );
			tagStr.push( ( "version" in playerData && playerData.version ) ? playerData.version : 0 );
			gaTag = tagStr.join( "|" );
		};

		var initializeComscore = function() {
			adDuration = 0;
			if ( "ns_" in window ) {
				comScore = new ns_.StreamingTag( {
					customerC2: "6034975",
				} );
			}
		};

		var setEventTypeString = function( str ) {
			if ( playerData.video_type === 2 ) {
				str += "-l";
			}
			return str;
		};

		var setPlayerEvents = function() {
			updateGATag();

			player.on( "ready", function() {
				videojs.log( this.id() + " analytics ready" );

				namespace._fireVideoEvent( "HRST_Diag", "render", playerData );
				// DIAGNOSTICS: Render
			} );

			player.on( "error", function() {
				videojs.log( this.id() + " analytics error: " + this.error() );

				namespace._fireVideoEvent( "HRST_Diag", "play_err", playerData, this.error() );
				// DIAGNOSTICS: Playback Error
			} );

			player.on( "playlistItem", function() {
				videojs.log( this.id() + " analytics playlistItem" );

				var videoId = this.playlist.sources[ this.playlist.currentIndex ].id;
				playerData.video_id = videoId;
				playerData.ad_tag_url = this.adTagUrl;
				updateGATag();
			} );

			// player.on( "playlistComplete", function() {
			// 	videojs.log( this.id() + " analytics playlistComplete" );

			// 	updateGATag();
			// 	sendAnalytics( "event", "Playback", "Video Playlist Completed", gaTag );
			// } );

			player.on( "readyforpreroll", function() {
				videojs.log( this.id() + " analytics view" );

				updateGATag();

				fireVideoView();
			} );

			player.on( "played-q0", function() {
				var eventStr = "start";
				eventStr = setEventTypeString( eventStr );

				videojs.log( this.id() + " analytics " + eventStr );

				updateGATag();

				fireVideoView();

				sendAnalytics( "event", "Playback", eventStr, gaTag );
				namespace._fireVideoEvent( "HRST_Playback", eventStr, playerData );

				comScoreFireEvent( "ContentType" );
			} );

			player.on( "play", function() {
				var el = this.contentEl().parentElement;
				namespace.pauseAllPlayers( el.getAttribute( "id" ), el.getAttribute( "data-player-id" ) );
			} );

			player.on( "play", function() {
				if ( ignoreNextPlay ) {
					ignoreNextPlay = false;
					return;
				}

				var eventStr = "play";
				eventStr = setEventTypeString( eventStr );

				videojs.log( this.id() + " analytics " + eventStr );

				updateGATag();

				sendAnalytics( "event", "Playback", eventStr, gaTag );
				namespace._fireVideoEvent( "HRST_Playback", eventStr, playerData );

				comScoreFireEvent( "ContentType" );
			} );

			player.on( "pause", function() {
				if ( ignoreNextPause ) {
					ignoreNextPause = false;
					return;
				}

				videojs.log( this.id() + " analytics pause" );

				updateGATag();
				var eventStr = setEventTypeString( "pause" );
				sendAnalytics( "event", "Playback", eventStr, gaTag );
				namespace._fireVideoEvent( "HRST_Playback", eventStr, playerData );

				comScoreStopEvent();
			} );

			player.on( "volumechange", function() {
				videojs.log( this.id() + " analytics volumechange: " + this.volume() );

				if ( this.muted() ) {
					namespace._fireVideoEvent( "HRST_Playback", "mute", playerData, this.muted() );
				} else {
					namespace._fireVideoEvent( "HRST_Playback", "vol", playerData, this.volume() );
				}
			} );

			// player.on( "texttrackchange", function() {
			// 	videojs.log( this.id() + " analytics texttrackchange" );

			// 	namespace._fireVideoEvent( "HRST_Playback", "capt", playerData );
			// } );

			player.on( "fullscreenchange", function() {
				videojs.log( this.id() + " analytics fullscreenchange: " + this.isFullscreen() );

				namespace._fireVideoEvent( "HRST_Playback", "fullsc", playerData, this.isFullscreen() );
			} );

			player.on( "resize", function() {
				var playerDimensions = Math.floor( this.currentWidth() ) + "x" + Math.floor( this.currentHeight() );

				videojs.log( this.id() + " analytics resize: " + playerDimensions );

				playerData.playerWidth = Math.floor( this.currentWidth() );
				playerData.playerHeight = Math.floor( this.currentHeight() );
			} );

			player.on( "played-q1", function() {
				videojs.log( this.id() + " analytics played-q1: " + this.currentTime() );

				updateGATag();
				sendAnalytics( "event", "Playback", "q1", gaTag );
				namespace._fireVideoEvent( "HRST_Playback", "q1", playerData );
			} );

			player.on( "played-q2", function() {
				videojs.log( this.id() + " analytics played-q2: " + this.currentTime() );

				updateGATag();
				sendAnalytics( "event", "Playback", "q2", gaTag );
				namespace._fireVideoEvent( "HRST_Playback", "q2", playerData );
			} );

			player.on( "played-q3", function() {
				videojs.log( this.id() + " analytics played-q3: " + this.currentTime() );

				updateGATag();
				sendAnalytics( "event", "Playback", "q3", gaTag );
				namespace._fireVideoEvent( "HRST_Playback", "q3", playerData );
			} );

			player.on( "played-q4", function() {
				videojs.log( this.id() + " analytics played-q4: " + this.currentTime() );

				updateGATag();
				sendAnalytics( "event", "Playback", "q4", gaTag );
				namespace._fireVideoEvent( "HRST_Playback", "q4", playerData );

				comScoreStopEvent();

				// set comScore to undefined after complete to instantiate a new one each time
				comScore = undefined;

				ignoreNextPlay = true;
				ignoreNextPause = true;
				beforePlay = false;
			} );

			player.on( "ads-ima-loaded", function() {
				videojs.log( this.id() + " analytics ads-ima-loaded" );

				fireVideoView();
				namespace._fireVideoEvent( "HRST_Ad", "req", playerData );
			} );

			player.on( "ads-ima-impression", function() {
				videojs.log( this.id() + " analytics ads-ima-impression" );

				namespace._fireVideoEvent( "HRST_Ad", "imp", playerData );
			} );

			player.on( "adserror", function( adEvent ) {
				if ( adEvent ) {
					videojs.log( this.id() + " analytics adserror: " + adEvent.data.AdError.toString() );
					namespace._fireVideoEvent( "HRST_Ad", "err", playerData, adEvent.data.AdError.toString() );
				} else {
					videojs.log( this.id() + " analytics adserror" );
					namespace._fireVideoEvent( "HRST_Ad", "err", playerData );
				}
			} );

			player.on( "ads-ad-started", function() {
				videojs.log( this.id() + " analytics ads-ad-started" );

				fireVideoView();
				namespace._fireVideoEvent( "HRST_Ad", "start", playerData );

				if ( this.ima && this.ima.currentAd ) {
					adDuration = this.ima.currentAd.getDuration();
					videojs.log( this.id() + " adDuration = " + adDuration );
					comScoreFireEvent( "AdType" );
				}
			} );

			player.on( "ads-ima-firstquartile", function() {
				videojs.log( this.id() + " analytics ads-ima-firstquartile q1" );

				namespace._fireVideoEvent( "HRST_Ad", "q1", playerData );
			} );

			player.on( "ads-ima-midpoint", function() {
				videojs.log( this.id() + " analytics ads-ima-midpoint q2" );

				namespace._fireVideoEvent("HRST_Ad", "q2", playerData );
			} );

			player.on( "ads-ima-thirdquartile", function() {
				videojs.log( this.id() + " analytics ads-ima-thirdquartile q3" );

				namespace._fireVideoEvent("HRST_Ad", "q3", playerData );
			} );

			player.on( "ads-ima-complete", function() {
				videojs.log( this.id() + " analytics ads-ima-complete q4" );

				namespace._fireVideoEvent( "HRST_Ad", "q4", playerData );
				comScoreStopEvent();

				if ( playerData.video_type === 2 ) {
					this.play();
				}
			} );

			// player.on( "ads-ima-start", function() {
			// 	videojs.log( this.id() + " analytics ads-ima-start" );

			// 	namespace._fireVideoEvent( "HRST_Ad", "vstart", playerData );
			// } );

			player.on( "ads-ima-click", function() {
				videojs.log( this.id() + " analytics ads-ima-click" );

				namespace._fireVideoEvent( "HRST_Ad", "click", playerData );
			} );

			player.on( "ads-ima-skip", function() {
				videojs.log( this.id() + " analytics ads-ima-skip" );

				namespace._fireVideoEvent( "HRST_Ad", "skip", playerData );
				comScoreStopEvent();
			} );
		};

		var fireVideoView = function() {
			if ( !beforePlay ) {
				beforePlay = true;
				updateGATag();
				var eventStr = setEventTypeString( "view" );
				sendAnalytics( "event", "Video", eventStr, gaTag );
				namespace._fireVideoEvent( "HRST_Playback", eventStr, playerData );
			}
		};

		var comScoreFireEvent = function( type ) {
			if ( comScore === undefined ) {
				initializeComscore();
			}
			var metadata = getComScoreMetdata( type),
				eventType = getComScoreMediaType( type );
			comScore[ ( type === "ContentType" ) ? "playVideoContentPart" : "playVideoAdvertisement" ]( metadata, eventType );
		};

		var comScoreStopEvent = function() {
			if ( comScore ) {
				comScore.stop();
			}
		};

		var getComScoreMetdata = function( type ) {
			var metadata = {
				ns_st_cl: parseInt( adDuration * 1000, 10 ) // Clip length in ms
			};

			if ( type === "ContentType" ) {
				var videoDuration = player.duration();
				if ( isNaN( videoDuration ) ) {
					videoDuration = 0;
				}

				metadata = merge( {}, metadata, {
					ns_st_cl: parseInt( videoDuration * 1000, 10 ), // Clip length in ms
					ns_st_ci: playerData.video_id, // Nitehawk response: id
					ns_st_st: "*null", // Station Title
					ns_st_pu: playerData.source_title, // Nitehawk response: media->source->title
					ns_st_pr: "*null", // Program Title
					ns_st_ep: playerData.video_title, // Nitehawk response: media->title
					ns_st_sn: "*null", // Episode Season Number
					ns_st_en: "*null", // Rover media_id
					ns_st_ge: playerData.category, // Nitehawk response: media.categories[0]->title
					ns_st_ti: "*null", // TMS ID (unavailable)
					ns_st_ia: "*null", // Identical Ad Assignment Flag
					ns_st_ce: "*null", // Complete Episode Flag
					ns_st_ddt: playerData.created_at, // Nitehawk response: created_at
					ns_st_tdt: "*null", // TV Air Date
					c3: playerData.domain, // Parent iFrame Domain (i.e. wjcl.com)
					c4: playerData.source_url, // Nitehawk response: media->source->url
					c6: "*null" // Unused Dictionary Classification Value
				} );
			} else {
				// reset adDuration to null for subsequent ads
				adDuration = 0;
			}

			return metadata;
		};

		var getComScoreMediaType = function( mediaType ) {
			// currently, we only use one video and one ad type; video.shortOnDemand and ad.preRoll respectively
			// eventually we will be using the other types in this object
			var mediaTypes = {
				ContentType: {
					longOnDemand: "LongFormOnDemand",
					shortOnDemand: "ShortFormOnDemand", // current default
					live: "Other",
					userLongOnDemand: "UserGeneratedLongFormOnDemand",
					userShortOnDemand: "UserGeneratedShortFormOnDemand",
					userLive: "UserGeneratedLive",
					bumper: "Bumper",
					other: "Other"
				},
				AdType: {
					preRoll: "LinearOnDemandPreRoll", // currently we only do pre-roll ads
					midRoll: "LinearOnDemandMidRoll",
					postRoll: "LinearOnDemandPostRoll",
					live: "LinearLive",
					other: "Other"
				}
			};
			return ns_.StreamingTag[ mediaType ][ mediaTypes[ mediaType ][ ( mediaType === "ContentType" ) ? "shortOnDemand" : "preRoll" ] ];
		};

		var sendAnalytics = function( dataType, category, action, label ) {
			var trackers = [];
			trackers.push( window.ga.getByName( "lumiereGaGroupId" ) );
			trackers.push( window.ga.getByName( "lumiereGaId" ) );

			trackers.forEach( function( tracker ) {
				if ( site_data.bu === "HTV" ) {
					setDimensions( tracker );
				}

				window.ga( tracker.get( "name" ) + ".set", "location", ( ( playerData.fullUrl ) ? playerData.fullUrl : "" ) );
				window.ga( tracker.get( "name" ) + ".set", "title", ( ( playerData.title ) ? playerData.title : "" ) );
				window.ga( tracker.get( "name" ) + ".send", dataType, category, action, label );
			} );
		};

		var setDimensions = function( tracker ) {
			if ( playerData.siteName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension2", playerData.siteName );
			}

			if ( playerData.articleSectionName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension3", playerData.articleSectionName );
			}
			if ( tracker.get( "dimension3" ) === undefined && playerData.channelName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension3", playerData.channelName );
			}

			if ( playerData.articleType ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension4", playerData.articleType );
			}

			if ( playerData.articleUniversalID ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension5", playerData.articleUniversalID );
			}

			if ( playerData.articleSubSectionName ) {
				window.ga(tracker.get( "name" ) + ".set", "dimension7", playerData.articleSubSectionName);
			}
			if ( tracker.get( "dimension7" ) === undefined && playerData.subChannelName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension7", playerData.subChannelName );
			}

			if ( playerData.articleSectionName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension8", playerData.articleSectionName );
			}
			if ( tracker.get( "dimension8" ) === undefined && playerData.channelName ) {
				window.ga(tracker.get( "name" ) + ".set", "dimension8", playerData.channelName );
			}

			if ( playerData.articleCollection ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension9", playerData.articleCollection );
			}
			if ( tracker.get( "dimension9" ) === undefined && playerData.contentCollectionName ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension9", playerData.contentCollectionName );
			}

			if ( playerData.clientId ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension10", playerData.clientId );
			}

			if ( playerData.timestamp ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension11", playerData.timestamp );
			}

			if ( playerData.articleRecommendationModel ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension12", playerData.articleRecommendationModel );
			}

			if ( playerData.articleSourceSite ) {
				window.ga( tracker.get( "name" ) + ".set", "dimension14", playerData.articleSourceSite );
			}
		};

		var isObj = function( obj ) {
			return ( typeof obj === "object" && typeof obj.length !== "number" );
		};

		var merge = function( target ) {
			var a, sourceProperty, property, source;

			target = ( typeof target !== "object" ) ? {} : target;

			for ( a = 1; ( source = arguments[ a ] ); a++ ) {
				for ( property in source ) {
					if ( source.hasOwnProperty( property ) ) {
						sourceProperty = source[ property ];
						if ( isObj( sourceProperty ) && isObj( target[ property ] ) ) {
							target[ property ] = merge( {}, target[ property ], sourceProperty );
							continue;
						}
						target[ property ] = sourceProperty;
					}
				}
			}

			return target;
		};

		init();
	};
})( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/events.js
// module id = 90
// module chunks = 0